import {GuidePostSerializer} from "@oldDashboard/legacyModels/serializers/guidePostSerializer";
import { legacyReportingGet } from "@oldDashboard/legacyUtils";

export class CommandListSize {
    async run(affiliateId: String, launchSelected: String, timePeriodSelected: String) {  
        const path = `get-chart-data/client:constituents-served/?affiliate_id=${affiliateId}&launch_id=${launchSelected}&time_period=${timePeriodSelected}`
        try {
            const response = await legacyReportingGet(path);
            return response
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) {
        const serializer = new GuidePostSerializer();
        return serializer.deserializeList(data);
    }
}

